export enum GroupProgressPlanPhaseVariants {
  BLUE = "blue",
  GREEN = "green",
  RED = "red",
}

export interface GroupProgressPlanPhase {
  id: string;
  title: string;
  subtitle: string;
  weeksDuration: number;
  variant: GroupProgressPlanPhaseVariants;
  description: string;
}
